const Amenities = {
    list: () => 'amenities',
    create:()=>'create/amenities',
    update: (id) => `update/amenities/${id}`,
    getById: (id) => `get/amenities/${id}`,
    delete: (id) => `delete/amenities/${id}`,
}
export default Amenities
